import  { useEffect, useState } from "react";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { RootState } from "../../../redux/rootReducers";
import { EmptyListPage, ErrorSuccessModal, TableLoader } from "../../commons";
import { useLocation } from "react-router-dom";
import { resetSession } from "../../../redux/auth";
import {
  addPerformanceEvaluationFeedbackAction,
  getPerformanceEvaluationListAction,
  getSinglePerformanceEvaluationDetailsAction,
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceSuccess,
  resetPerformanceEvaluationList,
  resetSinglePeDetailsList,
} from "../../../redux/mySpace";

import { LoginResponseType } from "../../../redux/auth/authTypes";
import {
  ALL_PERFORMANCE_EVALAUTION_HEADERS,
} from "../../../constant/tableHeadersConstants/checkInScheduleListHeader";
import {
  PerformanceEvaluationListType,
} from "../../../redux/mySpace/mySpaceTypes";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import PerformanceEvaluationTable from "./PerformanceEvaluationTable";
import ManagerViewPEFormModal from "./ManagerViewPEFormModal";
import {
  AddFeedbackPerformanceEvaluationPayloadType,
  GetPerformanceEvaluationPayloadType,
  GetSinglePerformanceEvaluationPayloadType,
} from "../../../commonTypes/mySpaceType";
import { BlobServiceClient } from "@azure/storage-blob";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
type DropDownType ={
  value:string;
  label:string;
}
type AppProps = {
  token: string | null;
  activeTab: string;
  history: any;
  singlePeDetailsList: any;
  fetching: boolean;
  success: number | null;
  error: string | null;
  message: string | null;
  statusCode: number | null;
  singlePeFetching:boolean;
  performanceEvaluationTotalCount: number;
  performanceEvaluationList: PerformanceEvaluationListType[] | [];
  loginData: LoginResponseType;
  dispatchResetSession: () => void;
  dispatchResetPerformanceEvaluationList: () => void;

  dispatchGetPerformanceEvaluationListAction: (
    data: GetPerformanceEvaluationPayloadType
  ) => void;
  dispatchAddPerformanceEvaluationFeedbackAction: (
    data: AddFeedbackPerformanceEvaluationPayloadType
  ) => void;
  dispatchResetMySpaceMessage: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchResetMySpaceSuccess: () => void;
  dispatchGetSinglePerformanceEvaluationDetailsAction: (
    data: GetSinglePerformanceEvaluationPayloadType
  ) => void;
  dispatchResetSinglePeDetailsList: () => void;
};
const AllPerformanceEvaluation = ({
  token,
  fetching,
  success,
  error,
  message,
  history,
  statusCode,
  loginData,
  singlePeDetailsList,
  singlePeFetching,
  dispatchResetSession,
  dispatchGetPerformanceEvaluationListAction,
  dispatchResetPerformanceEvaluationList,
  performanceEvaluationTotalCount,
  performanceEvaluationList,
  dispatchResetMySpaceMessage,
  dispatchResetMySpaceError,
  dispatchResetMySpaceSuccess,
  dispatchGetSinglePerformanceEvaluationDetailsAction,
  dispatchAddPerformanceEvaluationFeedbackAction,
  dispatchResetSinglePeDetailsList,
  activeTab,
}: AppProps) => {
  const { pathname } = useLocation();
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [data, setData] = useState<PerformanceEvaluationListType[]>([]);
  const [showOpenManagerFeedbackModal, setShowOpenManagerFeedbackModal] =
    useState(false);
  const [performanceEvaluationId, setPerformanceEvaluationId] = useState("");
  const [feedbackComment, setFeedbackComment] = useState("");
  const [performanceRating, setPerformanceRating] = useState({
    value: "",
    label: "Select..",
  });
  const search = useLocation().search;
  const redirectNotificationId = new URLSearchParams(search).get(
    "notification_id"
  );
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;
  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName: any = process.env.REACT_APP_USER_CONTAINER_NAME;
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const [uploadFetching, setUploadFetching] = useState(false);
  const [files, setFiles] = useState<any>([]);

  useEffect(() => {
    dispatchResetPerformanceEvaluationList();
    dispatchResetMySpaceError();
    dispatchResetMySpaceMessage();
    dispatchResetMySpaceSuccess();
    dispatchResetSinglePeDetailsList();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (performanceEvaluationList?.length === 0) {
      setData(performanceEvaluationList);
    } else if (offset > 0 && performanceEvaluationList?.length > 0) {
      setData((prv: PerformanceEvaluationListType[]) => [
        ...prv,
        ...performanceEvaluationList,
      ]);
    } else {
      setData(performanceEvaluationList);
    }
  }, [performanceEvaluationList]);

  useEffect(() => {
    if (singlePeDetailsList?.feedback) {
      setFeedbackComment(singlePeDetailsList?.feedback);
    } else {
      setFeedbackComment("");
    }
    if (singlePeDetailsList?.rating) {
      setPerformanceRating({
        value: singlePeDetailsList?.rating,
        label:
        singlePeDetailsList?.rating === 1
        ? "1 - Outstanding performer."
        : singlePeDetailsList?.rating === 2
        ? "2 - Exceeding expectations."
        : singlePeDetailsList?.rating === 3
        ? "3- Meeting all expectations."
        : singlePeDetailsList?.rating === 4
        ? "4 - Not meeting expectations."
        : singlePeDetailsList?.rating === 5?
        "5 - Issues in work performance and have to let go.":"",
      });
    }
  }, [singlePeDetailsList]);

  useEffect(() => {
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        role: "manager",
        notificationId: redirectNotificationId,

      };
      if (performanceEvaluationTotalCount) {
        if (performanceEvaluationTotalCount > offset) {
          dispatchGetPerformanceEvaluationListAction(finalData);
        }
      } else {
        dispatchGetPerformanceEvaluationListAction(finalData);
      }
    }
  }, [offset]);

  useEffect(()=>{
    if (success === 1 && message?.includes("added successfully!")) {
      dispatchResetPerformanceEvaluationList();
      dispatchResetMySpaceError();
      dispatchResetMySpaceMessage();
      dispatchResetMySpaceSuccess();
      toast.success(
        "Performance Evaluation feedback and rating details has been added successfully!",
        {
          duration: 2000,
        }
      );
      const finalData = {
        token,
        offset:0,
        limit,
        role: "manager",
      };
      if (offset === 0) {
        dispatchGetPerformanceEvaluationListAction(finalData);
      }
      else{
        setOffset(0)
      }
    }

  },[message])

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [performanceEvaluationList]);

  const toggleSubmitManagerFeedback = (data?: any) => {
    dispatchResetMySpaceError();
    if (data?._id) {
      setPerformanceEvaluationId(data?._id);
      let finalData = {
        token,
        performanceEvaluationId: data?._id,
      };
      dispatchGetSinglePerformanceEvaluationDetailsAction(finalData);
    }
    setShowOpenManagerFeedbackModal((prev: boolean) => !prev);
    setPerformanceRating({
      value: "",
      label: "Select..",
    })
    setFeedbackComment("")
    setFiles([])

  };

  const handlePerformanceRatingChange = (data: DropDownType) => {
    setPerformanceRating({
      value: data?.value,
      label: data?.label,
    });
  };
  const handleCommentChange = (e: string) => {
    setFeedbackComment(e);
  };
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +performanceEvaluationTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (performanceEvaluationList?.length > 0) {
          if (!fetching && offset < +performanceEvaluationTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  const uploadFiles = async (uploadedFile: any) => {
    const file = uploadedFile?.target?.files[0];
    try {
      setUploadFetching(true);
      let resp;
      const blockBlobClient = containerClient.getBlockBlobClient(
        new Date().valueOf() +
          "." +
          file.name.split(".")[file.name.split(".").length - 1]
      );
      resp = await blockBlobClient.uploadBrowserData(file);
      if (
        resp &&
        resp["_response"] &&
        resp["_response"].status &&
        resp["_response"].status === (201 || 200)
      ) {
        updateDocumentAPI(
          file.name,
          // file.id,
          blockBlobClient["_name"],
          blockBlobClient["_containerName"],
          file.type
        );
        setUploadFetching(false);
      } else {
        setUploadFetching(false);
        alert("something wrong");
      }
    } catch (error) {}
  };
  const getImageDetails = (data: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const updateDocumentAPI = (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: any = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };
    getImageDetails(data);
    if (files.length > 0) {
      setFiles((prevFiles: any) => [...prevFiles, data]);
    } else {
      setFiles([data]);
    }
  };
  const handleDeleteUploadedFile = (indexToDelete: number) => {
    const updatedFiles = files.filter(
      (_: any, index: number) => index !== indexToDelete
    );
    setFiles(updatedFiles);
  };
  const handleManagerFeedback = () => {
    if (token) {
      const finalData = {
        token,
        performanceEvaluationId,
        feedbackComment,
        performanceRating: performanceRating?.value,
        managerFileAttach:files
      };
      dispatchAddPerformanceEvaluationFeedbackAction(finalData);
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMySpaceError();
              dispatchResetMySpaceMessage();
              dispatchResetMySpaceSuccess();
            }}
          />
        );
      }
    }
  };

  return (
    <>
      <div className="header">
        <div className="left-header">
          <div className="heading mt-0">All PE List</div>
          {!fetching && performanceEvaluationTotalCount > 0 && (
            <div
              className="sub-heading"
              style={{ marginTop: "-22px" }}
            >{`Total ${
              performanceEvaluationTotalCount
                ? performanceEvaluationTotalCount
                : 0
            } list found`}</div>
          )}
        </div>
      </div>
      {fetching && offset==0? (
        <TableLoader Rows={10} ColumnPerRow={6} />
      ) : performanceEvaluationList?.length >0? (
        <PerformanceEvaluationTable
          tableHeader={ALL_PERFORMANCE_EVALAUTION_HEADERS}
          data={data}
          fetching={fetching}
          toggleSubmitManagerFeedback={toggleSubmitManagerFeedback}
        />
      ) : (
        !fetching && (
          <div className="p-5 mt-3">
            <EmptyListPage title="No List Found!" imageWidth="30%" />
          </div>
        )
      )}
      {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
      {showOpenManagerFeedbackModal && (
        <ManagerViewPEFormModal
          success={success}
          isOpen={showOpenManagerFeedbackModal}
          data={singlePeDetailsList}
          toggleSubmitManagerFeedback={toggleSubmitManagerFeedback}
          fetching={singlePeFetching}
          feedbackComment={feedbackComment}
          handleCommentChange={handleCommentChange}
          performanceRating={performanceRating}
          handlePerformanceRatingChange={handlePerformanceRatingChange}
          handleAddManagerFeedback={handleManagerFeedback}
          uploadFiles={uploadFiles}
          files={files}
          uploadFetching={uploadFetching}
          handleDeleteUploadedFile={handleDeleteUploadedFile}
        />
      )}

      {handleErrorModal()}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.mySpace.performanceEvaluationFetching,
  message: state.mySpace.message,
  success: state.mySpace.success,
  statusCode: state.mySpace.statusCode,
  error: state.mySpace.error,
  performanceEvaluationList: state.mySpace.performanceEvaluationList,
  performanceEvaluationTotalCount:
    state.mySpace.performanceEvaluationTotalCount,
  loginData: state.auth.loginData,
  singlePeDetailsList: state.mySpace.singlePeDetailsList,
  singlePeFetching:state.mySpace.singlePeFetching

});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetPerformanceEvaluationListAction: (
    data: GetPerformanceEvaluationPayloadType
  ) => dispatch(getPerformanceEvaluationListAction(data)),
  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchResetMySpaceMessage: () => dispatch(resetMySpaceMessage()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetPerformanceEvaluationList: () =>
    dispatch(resetPerformanceEvaluationList()),
  dispatchGetSinglePerformanceEvaluationDetailsAction: (
    data: GetSinglePerformanceEvaluationPayloadType
  ) => dispatch(getSinglePerformanceEvaluationDetailsAction(data)),
  dispatchAddPerformanceEvaluationFeedbackAction: (
    data: AddFeedbackPerformanceEvaluationPayloadType
  ) => dispatch(addPerformanceEvaluationFeedbackAction(data)),
  dispatchResetSinglePeDetailsList: () => dispatch(resetSinglePeDetailsList()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllPerformanceEvaluation);
